import { withStylePrefix } from '../common/withStylePrefix';
import { TooltipComponent, tooltipTemplate } from './Tooltip';
import styles from './Tooltip.styles.scss';
export const tooltipDefinition = {
    baseName: 'tooltip',
    template: tooltipTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonTooltip = TooltipComponent.compose(tooltipDefinition);
